<template>
  <!-- 预约观众详情页面 -->
  <div class="page-container">
    <!-- 观众信息卡片 -->
    <div class="page-card">
      <!-- 信息头部 -->
      <div class="page-card__header">
        <span style="font-weight: bold">预约观众详情</span>
      </div>

      <!-- 基本信息 -->
      <div style="padding: 16px; border-bottom: 1px solid var(--border-color)">
        <el-row :gutter="20">
          <el-col :span="2">
            <el-image
              src="https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/default.png"></el-image>
          </el-col>
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <div style="font-weight: bold; font-size: 14px; text-align: left">
                  姓名：{{infoData.name}}
                </div>
              </el-col>

              <el-col :span="6">
                <div class="content-info">手机： {{infoData.mobile}}</div>
              </el-col>
              <el-col :span="6">
                <div class="content-info">电子邮箱： {{infoData.email}}</div>
              </el-col>
              <el-col :span="6">
                <div class="content-info">身份证号： {{infoData.cardid}}</div>
              </el-col>
              <el-col :span="6">
                <div class="content-info">预约日期： {{infoData.create_time}}</div>
              </el-col>

              <el-col :span="12">
                <div class="content-info">所属公司： {{infoData.coname}}</div>
              </el-col>

              <el-col :span="6">
                <div class="content-info">职务： {{infoData.position}}</div>
              </el-col>

              <el-col :span="6">
                <div class="content-info">预约公司： {{infoData.user && infoData.user.name}}</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <!-- 扩展信息 -->
      <div style="padding: 16px; border-bottom: 1px solid var(--border-color)">
        <el-row>
          <el-col :span="6">
            <div class="content-info">公司性质： {{infoData.nature}}</div>
          </el-col>
          <el-col :span="6">
            <div class="content-info">兴趣产品： {{infoData.interest}}</div>
          </el-col>
          <el-col :span="6">
            <div class="content-info">产品用途： {{infoData.purpose}}</div>
          </el-col>
          <el-col :span="6">
            <div class="content-info">获知渠道： {{infoData.from}}</div>
          </el-col>
          <el-col :span="6">
            <div class="content-info">参观目的： {{infoData.objective}}</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "viewerDetail",
    data() {
      return {
        form: {
          name: '',
          content: '',
        },
        infoData: [],
        id: '',
      }
    },
    mounted() {
      // 初始化加载观众详情
      this.id = this.$route.query.id;
      this.getData();
    },

    methods: {
      // 获取观众详情数据
      getData() {
        let id = this.id;
        let url = this.baseUrl + "/admin/visits/" + id + '/';
        api.fetchData(url).then(res => {
          this.infoData = res;
        });
      },
    },
  }
</script>

<style scoped>
  .content-info {
    font-size: 13px;
    line-height: 30px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/viewerDetail.vue